module.exports = __webpack_public_path__ + "static/media/University-of-the-Highlands-and-Islands.1072848c.png";